// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Standard dashboard data table (reference: white card, grey headers, row rules only). */
.dashboard-data-table-panel,
.paid-media-table-panel {
  overflow: hidden;
  padding: 0;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 16px rgba(15, 23, 42, 0.06);
}

.dashboard-data-table-panel__header,
.paid-media-table-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  min-height: 102px;
  padding: 22px 28px;
  border-bottom: 1px solid #e6edf5;
}

.dashboard-data-table-panel__header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

/* Table-only shell when the table is not the full panel (e.g. inside another card body). */
.dashboard-data-table-card {
  overflow: hidden;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 16px rgba(15, 23, 42, 0.06);
}

.dashboard-data-table-card--nested {
  border: 0;
  border-radius: 0;
  box-shadow: none;
  background: #ffffff;
}

.dashboard-data-table-card--blueprint {
  border-radius: 8px;
  border-color: #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05), 0 2px 8px rgba(15, 23, 42, 0.04);
}

.dashboard-data-table-card--nested.dashboard-data-table-card--blueprint {
  border-radius: 0 0 8px 8px;
}

.dashboard-data-table--blueprint th,
.paid-media-table--blueprint th {
  background: #f8fafc;
  color: #475569;
  font-weight: 600;
  border-bottom-color: #e2e8f0;
}

.dashboard-data-table--blueprint.dashboard-data-table tbody td,
.paid-media-table--blueprint.paid-media-table tbody td {
  padding-top: 20px;
  padding-bottom: 20px;
}

.dashboard-data-table--blueprint.dashboard-data-table thead th,
.paid-media-table--blueprint.paid-media-table thead th {
  padding-top: 14px;
  padding-bottom: 14px;
}

.dashboard-data-table-panel__search,
.paid-media-table-panel__search {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-width: 400px;
  max-width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 1px solid #d7e1ee;
  border-radius: 8px;
  background: #ffffff;
  color: #64748b;
  box-shadow: inset 0 1px 1px rgba(15, 23, 42, 0.02);
}

.dashboard-data-table-panel__search input,
.paid-media-table-panel__search input {
  width: 100%;
  border: 0;
  background: transparent;
  padding-inline-start: 10px;
  color: #0f172a;
  font-size: 14px;
  outline: none;
}

.dashboard-data-table-panel__search input::placeholder,
.paid-media-table-panel__search input::placeholder {
  color: #64748b;
}

.dashboard-data-table-panel__search--small,
.paid-media-table-panel__search--small {
  min-width: 320px;
  height: 48px;
  margin-bottom: 0;
}

.dashboard-data-table-scroll,
.paid-media-table-wrap {
  overflow-x: auto;
}

.dashboard-data-table,
.paid-media-table {
  width: 100%;
  min-width: 980px;
  border-collapse: collapse;
}

.dashboard-data-table--compact {
  min-width: 0;
  width: 100%;
}

.dashboard-data-table th,
.paid-media-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 21px 20px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-align: start;
  text-transform: none;
  background: #ffffff;
  border-bottom: 1px solid #e8edf4;
  vertical-align: middle;
}

.dashboard-data-table thead th,
.paid-media-table thead th {
  white-space: nowrap;
}

.dashboard-data-table__sort,
.paid-media-table__sort {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-weight: inherit;
  cursor: pointer;
}

.dashboard-data-table__sort svg,
.paid-media-table__sort svg {
  flex-shrink: 0;
  opacity: 0.55;
  color: #94a3b8;
}

.dashboard-data-table__sort:hover svg,
.paid-media-table__sort:hover svg,
.dashboard-data-table__sort:focus-visible svg,
.paid-media-table__sort:focus-visible svg {
  opacity: 0.9;
  color: #64748b;
}

.dashboard-data-table__th--center .dashboard-data-table__sort,
.paid-media-table__th--center .paid-media-table__sort {
  justify-content: center;
  width: 100%;
}

.dashboard-data-table th.dashboard-data-table__number .dashboard-data-table__sort,
.paid-media-table th.paid-media-table__number .paid-media-table__sort {
  justify-content: flex-end;
  width: 100%;
}

/**
 * Header cell pairing a label / sort button with a (?) definition tooltip.
 * Both are inline-level boxes whose baselines sit at different heights (the
 * sort button baselines on its label text, the tooltip is middle-aligned), so
 * they must share a flex row to line up.
 */
.dashboard-data-table__th-help-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  vertical-align: middle;
  max-width: 100%;
}

.dashboard-data-table__th-help-row .definition-tooltip__trigger {
  transform: none;
}

.dashboard-data-table__th-help-row > .dashboard-data-table__sort,
.dashboard-data-table__th-help-row > .paid-media-table__sort {
  width: auto;
}

.dashboard-data-table thead th.dashboard-data-table__number .dashboard-data-table__th-help-row {
  width: 100%;
  justify-content: flex-end;
}

.dashboard-data-table thead th.dashboard-data-table__th--center .dashboard-data-table__th-help-row {
  width: 100%;
  justify-content: center;
}

.dashboard-data-table thead th:has(.dashboard-data-table__th-help-row) {
  overflow: visible;
}

.dashboard-data-table thead th:has(.dashboard-data-table__th-help-row .definition-tooltip:hover),
.dashboard-data-table thead th:has(.dashboard-data-table__th-help-row .definition-tooltip:focus-within) {
  z-index: 20;
}

.dashboard-data-table__th--center,
.paid-media-table__th--center {
  text-align: start !important;
}

.dashboard-data-table th.dashboard-data-table__number,
.paid-media-table th.paid-media-table__number {
  text-align: start !important;
}

.dashboard-data-table td,
.paid-media-table td {
  padding: 20px 20px;
  font-size: 14px;
  line-height: 1.35;
  color: #0f172a;
  vertical-align: middle;
  background: #ffffff;
  text-align: start !important;
}

.dashboard-data-table tbody td,
.paid-media-table tbody td {
  border-top: 1px solid #eef2f7;
}

.dashboard-data-table tbody tr:first-child td,
.paid-media-table tbody tr:first-child td {
  border-top: none;
}

.dashboard-data-table__td--center,
.paid-media-table__td--center {
  text-align: center !important;
}

.dashboard-data-table__cell--emphasis,
.paid-media-table__cell--emphasis {
  font-weight: 700;
  color: #0f172a;
}

.dashboard-data-table__empty,
.paid-media-table__empty {
  color: #94a3b8;
  font-weight: 400;
}

.dashboard-data-table tbody tr:hover td,
.paid-media-table tbody tr:hover td {
  background: #fafcff;
}

.dashboard-data-table__number,
.paid-media-table__number {
  text-align: end !important;
  font-variant-numeric: tabular-nums;
}

.dashboard-data-table__metric,
.paid-media-table__metric {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-weight: 700;
  font-size: 13px;
}

.dashboard-data-table td.dashboard-data-table__metric--success,
.dashboard-data-table td.paid-media-table__metric--success,
.paid-media-table td.paid-media-table__metric--success {
  color: #15803d;
}

.dashboard-data-table td.dashboard-data-table__metric--warning,
.dashboard-data-table td.paid-media-table__metric--warning,
.paid-media-table td.paid-media-table__metric--warning {
  color: #b45309;
}

.dashboard-data-table td.dashboard-data-table__metric--danger,
.dashboard-data-table td.paid-media-table__metric--danger,
.paid-media-table td.paid-media-table__metric--danger {
  color: #b91c1c;
}

.dashboard-data-table__empty-state {
  display: flex;
  min-height: 132px;
  padding: 28px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  text-align: center;
  border-top: 1px solid #eef2f7;
  background: #ffffff;
}

.dashboard-data-table__empty-state-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.dashboard-data-table__empty-state-description {
  font-size: 13px;
  color: #64748b;
}

@media (max-width: 768px) {
  .dashboard-data-table-panel__header,
  .paid-media-table-panel__header {
    min-height: 0;
    padding: 18px 18px 16px;
  }
  .dashboard-data-table-panel__search,
  .paid-media-table-panel__search,
  .dashboard-data-table-panel__search--small,
  .paid-media-table-panel__search--small {
    min-width: 100%;
    width: 100%;
  }
  .dashboard-data-table th,
  .paid-media-table th,
  .dashboard-data-table td,
  .paid-media-table td {
    padding-left: 16px;
    padding-right: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/DashboardDataTable/DashboardDataTable.scss"],"names":[],"mappings":"AAAA,yFAAA;AAEA;;EAEE,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,+EACE;AADJ;;AAKA;;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;AAFF;;AAKA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA,2FAAA;AACA;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,+EACE;AAHJ;;AAOA;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,qBAAA;EACA,8EACE;AALJ;;AASA;EACE,0BAAA;AANF;;AASA;;EAEE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AANF;;AASA;;EAEE,iBAAA;EACA,oBAAA;AANF;;AASA;;EAEE,iBAAA;EACA,oBAAA;AANF;;AASA;;EAEE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,kDAAA;AANF;;AASA;;EAEE,WAAA;EACA,SAAA;EACA,uBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;AANF;;AASA;;EAEE,cAAA;AANF;;AASA;;EAEE,gBAAA;EACA,YAAA;EACA,gBAAA;AANF;;AASA;;EAEE,gBAAA;AANF;;AASA;;EAEE,WAAA;EACA,gBAAA;EACA,yBAAA;AANF;;AASA;EACE,YAAA;EACA,WAAA;AANF;;AASA;;EAEE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;EACA,sBAAA;AANF;;AASA;;EAEE,mBAAA;AANF;;AASA;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;AANF;;AASA;;EAEE,cAAA;EACA,aAAA;EACA,cAAA;AANF;;AASA;;;;EAIE,YAAA;EACA,cAAA;AANF;;AASA;;EAEE,uBAAA;EACA,WAAA;AANF;;AASA;;EAEE,yBAAA;EACA,WAAA;AANF;;AASA;;;;;EAAA;AAMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,eAAA;AANF;;AAUA;EACE,eAAA;AAPF;;AAYA;;EAEE,WAAA;AATF;;AAYA;EACE,WAAA;EACA,yBAAA;AATF;;AAYA;EACE,WAAA;EACA,uBAAA;AATF;;AAaA;EACE,iBAAA;AAVF;;AAaA;;EAEE,WAAA;AAVF;;AAaA;;EAEE,4BAAA;AAVF;;AAaA;;EAEE,4BAAA;AAVF;;AAaA;;EAEE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;AAVF;;AAaA;;EAEE,6BAAA;AAVF;;AAaA;;EAEE,gBAAA;AAVF;;AAaA;;EAEE,6BAAA;AAVF;;AAaA;;EAEE,gBAAA;EACA,cAAA;AAVF;;AAaA;;EAEE,cAAA;EACA,gBAAA;AAVF;;AAaA;;EAEE,mBAAA;AAVF;;AAaA;;EAEE,0BAAA;EACA,kCAAA;AAVF;;AAaA;;EAEE,gGAAA;EACA,gBAAA;EACA,eAAA;AAVF;;AAaA;;;EAGE,cAAA;AAVF;;AAaA;;;EAGE,cAAA;AAVF;;AAaA;;;EAGE,cAAA;AAVF;;AAaA;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAVF;;AAaA;EACE,eAAA;EACA,cAAA;AAVF;;AAaA;EACE;;IAEE,aAAA;IACA,uBAAA;EAVF;EAaA;;;;IAIE,eAAA;IACA,WAAA;EAXF;EAcA;;;;IAIE,kBAAA;IACA,mBAAA;EAZF;AACF","sourcesContent":["/* Standard dashboard data table (reference: white card, grey headers, row rules only). */\n\n.dashboard-data-table-panel,\n.paid-media-table-panel {\n  overflow: hidden;\n  padding: 0;\n  border-radius: 16px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 4px 16px rgba(15, 23, 42, 0.06);\n}\n\n.dashboard-data-table-panel__header,\n.paid-media-table-panel__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  min-height: 102px;\n  padding: 22px 28px;\n  border-bottom: 1px solid #e6edf5;\n}\n\n.dashboard-data-table-panel__header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n/* Table-only shell when the table is not the full panel (e.g. inside another card body). */\n.dashboard-data-table-card {\n  overflow: hidden;\n  border-radius: 16px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 4px 16px rgba(15, 23, 42, 0.06);\n}\n\n.dashboard-data-table-card--nested {\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  background: #ffffff;\n}\n\n.dashboard-data-table-card--blueprint {\n  border-radius: 8px;\n  border-color: #e2e8f0;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.05),\n    0 2px 8px rgba(15, 23, 42, 0.04);\n}\n\n.dashboard-data-table-card--nested.dashboard-data-table-card--blueprint {\n  border-radius: 0 0 8px 8px;\n}\n\n.dashboard-data-table--blueprint th,\n.paid-media-table--blueprint th {\n  background: #f8fafc;\n  color: #475569;\n  font-weight: 600;\n  border-bottom-color: #e2e8f0;\n}\n\n.dashboard-data-table--blueprint.dashboard-data-table tbody td,\n.paid-media-table--blueprint.paid-media-table tbody td {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.dashboard-data-table--blueprint.dashboard-data-table thead th,\n.paid-media-table--blueprint.paid-media-table thead th {\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n\n.dashboard-data-table-panel__search,\n.paid-media-table-panel__search {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  min-width: 400px;\n  max-width: 100%;\n  height: 48px;\n  padding: 0 16px;\n  border: 1px solid #d7e1ee;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #64748b;\n  box-shadow: inset 0 1px 1px rgba(15, 23, 42, 0.02);\n}\n\n.dashboard-data-table-panel__search input,\n.paid-media-table-panel__search input {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  padding-inline-start: 10px;\n  color: #0f172a;\n  font-size: 14px;\n  outline: none;\n}\n\n.dashboard-data-table-panel__search input::placeholder,\n.paid-media-table-panel__search input::placeholder {\n  color: #64748b;\n}\n\n.dashboard-data-table-panel__search--small,\n.paid-media-table-panel__search--small {\n  min-width: 320px;\n  height: 48px;\n  margin-bottom: 0;\n}\n\n.dashboard-data-table-scroll,\n.paid-media-table-wrap {\n  overflow-x: auto;\n}\n\n.dashboard-data-table,\n.paid-media-table {\n  width: 100%;\n  min-width: 980px;\n  border-collapse: collapse;\n}\n\n.dashboard-data-table--compact {\n  min-width: 0;\n  width: 100%;\n}\n\n.dashboard-data-table th,\n.paid-media-table th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  padding: 21px 20px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  text-align: start;\n  text-transform: none;\n  background: #ffffff;\n  border-bottom: 1px solid #e8edf4;\n  vertical-align: middle;\n}\n\n.dashboard-data-table thead th,\n.paid-media-table thead th {\n  white-space: nowrap;\n}\n\n.dashboard-data-table__sort,\n.paid-media-table__sort {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-weight: inherit;\n  cursor: pointer;\n}\n\n.dashboard-data-table__sort svg,\n.paid-media-table__sort svg {\n  flex-shrink: 0;\n  opacity: 0.55;\n  color: #94a3b8;\n}\n\n.dashboard-data-table__sort:hover svg,\n.paid-media-table__sort:hover svg,\n.dashboard-data-table__sort:focus-visible svg,\n.paid-media-table__sort:focus-visible svg {\n  opacity: 0.9;\n  color: #64748b;\n}\n\n.dashboard-data-table__th--center .dashboard-data-table__sort,\n.paid-media-table__th--center .paid-media-table__sort {\n  justify-content: center;\n  width: 100%;\n}\n\n.dashboard-data-table th.dashboard-data-table__number .dashboard-data-table__sort,\n.paid-media-table th.paid-media-table__number .paid-media-table__sort {\n  justify-content: flex-end;\n  width: 100%;\n}\n\n/**\n * Header cell pairing a label / sort button with a (?) definition tooltip.\n * Both are inline-level boxes whose baselines sit at different heights (the\n * sort button baselines on its label text, the tooltip is middle-aligned), so\n * they must share a flex row to line up.\n */\n.dashboard-data-table__th-help-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  vertical-align: middle;\n  max-width: 100%;\n}\n\n// The 1px nudge is tuned for KPI card headings, not table header rows.\n.dashboard-data-table__th-help-row .definition-tooltip__trigger {\n  transform: none;\n}\n\n// Undo the full-width stretch the number / center rules above put on the sort\n// button; the wrapper owns the alignment now.\n.dashboard-data-table__th-help-row > .dashboard-data-table__sort,\n.dashboard-data-table__th-help-row > .paid-media-table__sort {\n  width: auto;\n}\n\n.dashboard-data-table thead th.dashboard-data-table__number .dashboard-data-table__th-help-row {\n  width: 100%;\n  justify-content: flex-end;\n}\n\n.dashboard-data-table thead th.dashboard-data-table__th--center .dashboard-data-table__th-help-row {\n  width: 100%;\n  justify-content: center;\n}\n\n// A popover opening from a header must not be clipped by the cell.\n.dashboard-data-table thead th:has(.dashboard-data-table__th-help-row) {\n  overflow: visible;\n}\n\n.dashboard-data-table thead th:has(.dashboard-data-table__th-help-row .definition-tooltip:hover),\n.dashboard-data-table thead th:has(.dashboard-data-table__th-help-row .definition-tooltip:focus-within) {\n  z-index: 20;\n}\n\n.dashboard-data-table__th--center,\n.paid-media-table__th--center {\n  text-align: start !important;\n}\n\n.dashboard-data-table th.dashboard-data-table__number,\n.paid-media-table th.paid-media-table__number {\n  text-align: start !important;\n}\n\n.dashboard-data-table td,\n.paid-media-table td {\n  padding: 20px 20px;\n  font-size: 14px;\n  line-height: 1.35;\n  color: #0f172a;\n  vertical-align: middle;\n  background: #ffffff;\n  text-align: start !important;\n}\n\n.dashboard-data-table tbody td,\n.paid-media-table tbody td {\n  border-top: 1px solid #eef2f7;\n}\n\n.dashboard-data-table tbody tr:first-child td,\n.paid-media-table tbody tr:first-child td {\n  border-top: none;\n}\n\n.dashboard-data-table__td--center,\n.paid-media-table__td--center {\n  text-align: center !important; \n}\n\n.dashboard-data-table__cell--emphasis,\n.paid-media-table__cell--emphasis {\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.dashboard-data-table__empty,\n.paid-media-table__empty {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.dashboard-data-table tbody tr:hover td,\n.paid-media-table tbody tr:hover td {\n  background: #fafcff;\n}\n\n.dashboard-data-table__number,\n.paid-media-table__number {\n  text-align: end !important;\n  font-variant-numeric: tabular-nums;\n}\n\n.dashboard-data-table__metric,\n.paid-media-table__metric {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", monospace;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.dashboard-data-table td.dashboard-data-table__metric--success,\n.dashboard-data-table td.paid-media-table__metric--success,\n.paid-media-table td.paid-media-table__metric--success {\n  color: #15803d;\n}\n\n.dashboard-data-table td.dashboard-data-table__metric--warning,\n.dashboard-data-table td.paid-media-table__metric--warning,\n.paid-media-table td.paid-media-table__metric--warning {\n  color: #b45309;\n}\n\n.dashboard-data-table td.dashboard-data-table__metric--danger,\n.dashboard-data-table td.paid-media-table__metric--danger,\n.paid-media-table td.paid-media-table__metric--danger {\n  color: #b91c1c;\n}\n\n.dashboard-data-table__empty-state {\n  display: flex;\n  min-height: 132px;\n  padding: 28px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 8px;\n  text-align: center;\n  border-top: 1px solid #eef2f7;\n  background: #ffffff;\n}\n\n.dashboard-data-table__empty-state-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.dashboard-data-table__empty-state-description {\n  font-size: 13px;\n  color: #64748b;\n}\n\n@media (max-width: 768px) {\n  .dashboard-data-table-panel__header,\n  .paid-media-table-panel__header {\n    min-height: 0;\n    padding: 18px 18px 16px;\n  }\n\n  .dashboard-data-table-panel__search,\n  .paid-media-table-panel__search,\n  .dashboard-data-table-panel__search--small,\n  .paid-media-table-panel__search--small {\n    min-width: 100%;\n    width: 100%;\n  }\n\n  .dashboard-data-table th,\n  .paid-media-table th,\n  .dashboard-data-table td,\n  .paid-media-table td {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
